import { render } from "./component-icon.vue?vue&type=template&id=ba1b603a"
const script = {}

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__